var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmEventMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.332V7.905C3.75 4.46 6.55 1.667 10 1.667s6.25 2.793 6.25 6.238v4.427l1.183 2.364a.624.624 0 01-.559.902H3.126a.624.624 0 01-.56-.902l1.185-2.364zm12.113 2.019l-.798-1.593A.623.623 0 0115 12.48V7.905A4.995 4.995 0 0010 2.915c-2.761 0-5 2.234-5 4.99v4.574a.625.625 0 01-.065.28l-.798 1.592h11.726zm-8.658 2.975a.623.623 0 01-.081-.879.626.626 0 01.88-.08c.56.466 1.267.72 1.996.718a3.113 3.113 0 001.996-.718.626.626 0 011.022.537.623.623 0 01-.223.422A4.363 4.363 0 0110 18.333a4.362 4.362 0 01-2.795-1.007z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmEventMgt);
export default __webpack_public_path__ + "static/assets/alarmEventMgt.4f3c4f1a.svg";
export { ForwardRef as ReactComponent };